import { useEffect, useState } from "react";
import ReactModal from "react-modal";
import useHardwareSubscription from "@hooks/useHardwareSubscription";
import { SubscriptionStatus } from "@providers/profile/ProfileProvider.model";
import AccountTransferForm from "./AccountTransferForm";
import { APPLICATION_NODE } from "@utils/constants";
import { SubText } from "../../Account.styled";
import ModalContainer from "@components/modals/ModalContainer";

const AccountTransfer = () => {
  const subscription = useHardwareSubscription();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (typeof document !== "undefined") {
      ReactModal.setAppElement(document.getElementById(APPLICATION_NODE));
    }
  }, []);

  const country = process.env.NEXT_PUBLIC_COUNTRY_CODE === "CA" ? "Canada" : "US";

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <>
      <>
        <dt>Transfer Account</dt>
        <dd>
          <button onClick={toggleModal}>Start transfer</button>
          <SubText>
            Transferring a lululemon Studio account will transfer the account to another Member. The
            new account holder will be required to accept ownership and begin a 12-month lululemon
            Studio Membership commitment in order to complete the transfer.
            <br />
            Accounts may only be transferred within {country}.
          </SubText>
        </dd>
      </>
      <ModalContainer
        data-testid="modal-container"
        toggleModal={toggleModal}
        mounted={isModalOpen}
        maxWidth={550}>
        <AccountTransferForm />
      </ModalContainer>
    </>
  );
};

export default AccountTransfer;
